<template>
    <div id="opening-periods-section" class="mb-5 periods opening-period-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span v-if="!newTitle">
                  Périodes et horaires d'ouverture
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "OpeningHours",
    components: {FormComponentLoader},
    props: ["index", "newTitle", "helpDesc"],
    computed: {
        ...mapState('webFormStyle', ['titlesColor', 'primaryColor']),
        ...mapGetters('web_form', ['getFieldsFromTabulation']),
        tabulationFields() {
            let fields = this.getFieldsFromTabulation('OPENING_HOURS').sort((a, b) => a.order - b.order)

            fields.forEach(field => {
                if (field.fieldable.code !== 'OPENING_HOURS') {
                    // pour ne pas afficher les composants à la suite dans le FormComponentLoader
                    // les périodes sont traitées spécifiquement pour l'affichage des fields
                    field.hiddenInRoot = true
                }
            })

            return fields
        }
    }
}
</script>
